import { Toolbox } from '~/plugins/toolbox/shared'
import { Oauth2Popup } from '../../activepieces/helpers/oauth2Popup'
import { Oauth2ClientType } from '../../authentication/strategies/oauth2/oauth2client'
import { ProviderClient } from '../../providers/abstract/provider.client'

export const useStrategyOauth2 = () => {
  const start = async (
    provider: ProviderClient,
    options?: {
      input?: any
      scopes?: string[]
      extraParams?: Record<string, any>
    },
  ) => {
    const { input = {}, scopes, extraParams = {} } = options
    const authentication = provider.authentication as Oauth2ClientType

    const authUrl = Toolbox.Token.apply(authentication.authUrl, { input })

    const scope = scopes ? scopes.join(' ') : authentication.scopes.join(' ')

    const providerAuthParams = authentication.authParams ?? {}

    const response = await Oauth2Popup.open({
      authUrl,
      clientId: authentication.clientId,
      redirectUrl: authentication.redirectUrl,
      scope: scope?.length > 0 ? scope : undefined,
      pkce: false,
      extraParams: { ...providerAuthParams, ...extraParams },
    })

    return { ...response, input }
  }

  return {
    start,
  }
}
